<template>
  <div>
    <a-card :loading="bootLoading">
      <div slot="title">
        <a-button type="link" icon="arrow-left" @click="$router.push('/orderForm/forms')" style="padding-left:0">返回</a-button>
        <span>{{ form.title || '表单配置' }}</span>
      </div>
      <div slot="extra">
        <a :href="publicUrl" target="_blank" style="margin-right:12px">打开公开页</a>
        <a-button type="link" style="padding:0" @click="openShare">分享（H5+小程序）</a-button>
      </div>

      <a-tabs v-model="tab">
        <a-tab-pane key="category" tab="分类管理">
          <div style="margin-bottom: 12px;">
            <a-button type="primary" icon="plus" @click="openCategory({})">新增分类</a-button>
          </div>
          <a-table size="small" rowKey="id" :columns="categoryColumns" :dataSource="categories" :pagination="false">
            <div slot="is_active" slot-scope="v"><a-tag :color="v?'green':'red'">{{ v?'启用':'停用' }}</a-tag></div>
            <div slot="action" slot-scope="v, item">
              <a-button size="small" icon="edit" @click="openCategory(item)">编辑</a-button>
              <a-popconfirm title="确定删除该分类？" @confirm="removeCategory(item.id)">
                <a-button size="small" type="danger" icon="delete" style="margin-left:8px">删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="banner" tab="轮播图">
          <div style="margin-bottom:12px">
            <a-button type="primary" icon="plus" @click="openBanner({})">新增轮播图</a-button>
            <span style="margin-left:12px;color:#999;font-size:12px">
              显示在报价单顶部，可点击跳到某个套餐产品或分类；建议图片比例 2:1（如 1000×500）
            </span>
          </div>
          <a-table size="small" rowKey="id" :columns="bannerColumns" :dataSource="banners"
            :loading="bannerLoading" :pagination="false">
            <div slot="image" slot-scope="v">
              <img v-if="v" :src="v" style="width:120px;height:60px;object-fit:cover;border-radius:6px" />
            </div>
            <div slot="link" slot-scope="v, item">
              <span v-if="item.link_type === 'product'">产品：{{ item.product_name || '—' }}</span>
              <span v-else-if="item.link_type === 'category'">分类：{{ item.category_name || '—' }}</span>
              <span v-else style="color:#999">不跳转</span>
            </div>
            <div slot="is_active" slot-scope="v"><a-tag :color="v?'green':'red'">{{ v?'启用':'停用' }}</a-tag></div>
            <div slot="action" slot-scope="v, item">
              <a-button size="small" icon="edit" @click="openBanner(item)">编辑</a-button>
              <a-popconfirm title="确定删除该轮播图？" @confirm="removeBanner(item.id)">
                <a-button size="small" type="danger" icon="delete" style="margin-left:8px">删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="product" tab="产品管理">
          <a-row gutter="12" style="margin-bottom:12px">
            <a-col :span="6">
              <a-select v-model="productFilter.category" allowClear placeholder="全部分类" style="width:100%" @change="loadProducts">
                <a-select-option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="6">
              <a-input v-model="productFilter.search" placeholder="名称/成分/防治" allowClear @pressEnter="loadProducts" />
            </a-col>
            <a-col :span="3">
              <a-button type="primary" icon="search" @click="loadProducts">查询</a-button>
            </a-col>
            <a-col :span="9" style="text-align:right">
              <a-button icon="link" style="margin-right:8px" :loading="linkLoading" @click="linkGoods">一键关联ERP库存</a-button>
              <a-button icon="file-excel" style="margin-right:8px" @click="downloadTemplate">下载模板</a-button>
              <a-upload name="file" :showUploadList="false" :customRequest="importExcel" accept=".xlsx,.xls" style="margin-right:8px">
                <a-button icon="upload" :loading="importLoading">Excel导入</a-button>
              </a-upload>
              <a-button type="primary" icon="plus" @click="openProduct({})">新增产品</a-button>
            </a-col>
          </a-row>
          <div v-if="importLoading" style="margin-bottom:12px;color:#999"><a-spin style="margin-right:8px" />正在导入报价单，请稍候…</div>
          <a-table size="small" rowKey="id" :columns="productColumns" :dataSource="products"
            :loading="productLoading" :pagination="productPagination" @change="productTableChange">
            <div slot="cover" slot-scope="v">
              <img v-if="v" :src="v" style="width:44px;height:44px;object-fit:cover;border-radius:6px" />
              <span v-else style="color:#ccc;font-size:12px">无</span>
            </div>
            <div slot="specs" slot-scope="v, item">
              <div v-for="s in (v||[])" :key="s.id" style="font-size:12px;line-height:1.6">
                {{ s.name }}：¥{{ s.price }} / 库存{{ displaySpecStock(item, s) }}
                <span v-if="item.goods" style="color:#999">（ERP）</span>
              </div>
            </div>
            <div slot="is_active" slot-scope="v"><a-tag :color="v?'green':'red'">{{ v?'启用':'停用' }}</a-tag></div>
            <div slot="action" slot-scope="v, item">
              <a-button size="small" icon="edit" @click="openProduct(item)">编辑</a-button>
              <a-popconfirm title="确定删除该产品？" @confirm="removeProduct(item.id)">
                <a-button size="small" type="danger" icon="delete" style="margin-left:8px">删除</a-button>
              </a-popconfirm>
            </div>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <!-- 分类弹窗 -->
    <a-modal v-model="catVisible" :confirmLoading="saving" title="分类" @ok="saveCategory" @cancel="catVisible=false">
      <a-form-model :model="catForm" :label-col="{span:5}" :wrapper-col="{span:17}">
        <a-form-model-item label="名称" required>
          <a-input v-model="catForm.name" placeholder="如：小麦除草剂" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="catForm.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="启用">
          <a-switch v-model="catForm.is_active" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 轮播图弹窗 -->
    <a-modal v-model="bannerVisible" :confirmLoading="saving" title="轮播图" width="640px"
      @ok="saveBanner" @cancel="bannerVisible=false">
      <a-form-model :model="bannerForm" :label-col="{span:5}" :wrapper-col="{span:17}">
        <a-form-model-item label="图片" required>
          <a-upload :showUploadList="false" :customRequest="uploadBanner" accept="image/*">
            <a-button icon="upload" :loading="bannerUploading">上传图片</a-button>
          </a-upload>
          <a-input v-model="bannerForm.image" placeholder="或直接填写图片地址" allowClear style="margin-top:8px" />
          <img v-if="bannerForm.image" :src="bannerForm.image"
            style="margin-top:8px;width:100%;max-height:200px;object-fit:cover;border-radius:8px" />
        </a-form-model-item>
        <a-form-model-item label="标题">
          <a-input v-model="bannerForm.title" placeholder="如：小麦套餐 A（选填，显示在图片左下角）" />
        </a-form-model-item>
        <a-form-model-item label="点击跳转">
          <a-radio-group v-model="bannerForm.link_type" button-style="solid" size="small">
            <a-radio-button value="none">不跳转</a-radio-button>
            <a-radio-button value="product">指定产品</a-radio-button>
            <a-radio-button value="category">指定分类</a-radio-button>
          </a-radio-group>
          <a-select v-if="bannerForm.link_type === 'product'" v-model="bannerForm.product"
            show-search option-filter-prop="children" placeholder="选择套餐产品" style="width:100%;margin-top:8px">
            <a-select-option v-for="p in bannerProducts" :key="p.id" :value="p.id">
              {{ p.name }}（{{ p.category_name }}）
            </a-select-option>
          </a-select>
          <a-select v-if="bannerForm.link_type === 'category'" v-model="bannerForm.category"
            placeholder="选择分类" style="width:100%;margin-top:8px">
            <a-select-option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="bannerForm.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="启用">
          <a-switch v-model="bannerForm.is_active" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 产品弹窗 -->
    <a-modal v-model="prodVisible" :confirmLoading="saving" :maskClosable="false" width="820px"
      :title="prodForm.id ? '编辑产品' : '新增产品'" @ok="saveProduct" @cancel="prodVisible=false">
      <a-form-model :model="prodForm" :label-col="{span:4}" :wrapper-col="{span:19}">
        <a-form-model-item label="分类" required>
          <a-select v-model="prodForm.category" style="width:100%" placeholder="选择分类">
            <a-select-option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="产品名称" required>
          <a-input v-model="prodForm.name" />
        </a-form-model-item>
        <a-form-model-item label="产品图片">
          <div style="display:flex;align-items:flex-start;gap:12px">
            <div>
              <a-upload :showUploadList="false" :customRequest="uploadCover" accept="image/*">
                <a-button icon="upload" :loading="coverUploading">上传图片</a-button>
              </a-upload>
              <a-button v-if="prodForm.cover" type="link" size="small" style="padding:0;margin-left:8px"
                @click="$set(prodForm, 'cover', '')">移除</a-button>
              <a-input v-model="prodForm.cover" placeholder="或直接填写图片地址" allowClear style="margin-top:8px;width:360px" />
              <div style="color:#999;font-size:12px;margin-top:4px">
                建议正方形（如 400×400）。顾客端是否展示由表单的「产品图片」开关控制
              </div>
            </div>
            <img v-if="prodForm.cover" :src="prodForm.cover"
              style="width:88px;height:88px;object-fit:cover;border-radius:8px;border:1px solid #eaecf0" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="关联产品">
          <goods-select
            v-model="prodForm.goods"
            placeholder="选择 ERP 产品以同步真实库存"
            :defaultItem="{ goods: prodForm.goods, goods_name: prodForm.goods_name }"
            @change="onGoodsChange"
          />
          <div v-if="prodForm.goods" style="margin-top:6px;color:#666;font-size:12px">
            ERP 可售库存：{{ prodForm.real_stock != null ? prodForm.real_stock : '—' }}
            <span v-if="prodForm.goods_number">（{{ prodForm.goods_number }}）</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="成分">
          <a-textarea v-model="prodForm.ingredients" :rows="2" placeholder="有效成分及含量" />
        </a-form-model-item>
        <a-form-model-item label="主要防治">
          <a-textarea v-model="prodForm.control_targets" :rows="2" placeholder="主要防治的病虫草害" />
        </a-form-model-item>
        <a-form-model-item label="使用量">
          <a-input v-model="prodForm.dosage" placeholder="如：每亩 30-40 毫升" />
        </a-form-model-item>
        <a-form-model-item label="详情说明">
          <a-textarea v-model="prodForm.detail" :rows="3" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="prodForm.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="启用">
          <a-switch v-model="prodForm.is_active" />
        </a-form-model-item>

        <a-divider>规格价格</a-divider>
        <div v-if="prodForm.goods" style="margin-bottom:8px;color:#999;font-size:12px">
          已关联 ERP 产品，公开页库存以 ERP 可售库存为准；下方「库存」仅作未关联时的备用值。
        </div>
        <div v-for="(spec, idx) in prodForm.specs" :key="idx" class="spec-row">
          <a-input v-model="spec.name" placeholder="规格" style="width:120px;margin-right:8px" />
          <a-input-number v-model="spec.price" :min="0" :precision="2" placeholder="现价" style="width:110px;margin-right:8px" />
          <a-input-number v-model="spec.original_price" :min="0" :precision="2" placeholder="原价" style="width:110px;margin-right:8px" />
          <a-input-number v-model="spec.stock" :min="0" placeholder="库存" style="width:100px;margin-right:8px" :disabled="!!prodForm.goods" />
          <a-input v-model="spec.unit" placeholder="单位" style="width:70px;margin-right:8px" />
          <a-button type="danger" icon="delete" @click="prodForm.specs.splice(idx,1)" />
        </div>
        <a-button type="dashed" icon="plus" block style="margin-top:8px" @click="addSpec">添加规格</a-button>
      </a-form-model>
    </a-modal>

    <a-modal v-model="shareVisible" title="分享报价单（H5 + 小程序）" :footer="null" width="520px" @cancel="shareVisible=false">
      <a-spin :spinning="shareLoading">
        <div v-if="share">
          <div style="margin-bottom:12px"><b>{{ share.title || form.title }}</b></div>
          <div style="font-size:12px;color:#666;margin-bottom:8px">H5 公开填单页</div>
          <a-input readOnly :value="shareH5Url" style="margin-bottom:8px">
            <a-button slot="addonAfter" @click="copyText(shareH5Url)">复制</a-button>
          </a-input>
          <a :href="shareH5Url" target="_blank" style="font-size:12px">打开公开页</a>
          <a-divider style="margin:16px 0" />
          <div style="font-size:12px;color:#666;margin-bottom:8px">小程序路径</div>
          <a-input readOnly :value="share.path" style="margin-bottom:8px">
            <a-button slot="addonAfter" @click="copyText(share.path)">复制路径</a-button>
          </a-input>
          <div style="font-size:12px;color:#666;margin:12px 0 8px">小程序 URL Link</div>
          <a-input readOnly :value="share.url_link || '生成失败，请检查小程序配置'" style="margin-bottom:8px">
            <a-button slot="addonAfter" :disabled="!share.url_link" @click="copyText(share.url_link)">复制链接</a-button>
          </a-input>
          <div v-if="share.url_link_error" style="color:#c0392b;font-size:12px;margin-bottom:8px">{{ share.url_link_error }}</div>
          <div style="text-align:center;margin-top:16px">
            <div style="font-size:12px;color:#666;margin-bottom:8px">微信扫码进入小程序</div>
            <img v-if="share.qrcode" :src="share.qrcode" alt="小程序码" style="width:220px;height:220px" />
            <div v-else style="color:#999;padding:40px 0">{{ share.qrcode_error || '小程序码暂不可用' }}</div>
          </div>
          <div style="margin-top:12px;color:#999;font-size:12px;line-height:1.5">{{ share.tip }}</div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import {
  orderFormDetail,
  orderFormCategoryList, orderFormCategoryCreate, orderFormCategoryUpdate, orderFormCategoryDestroy,
  orderFormProductList, orderFormProductCreate, orderFormProductUpdate, orderFormProductDestroy,
  orderFormBannerList, orderFormBannerCreate, orderFormBannerUpdate, orderFormBannerDestroy,
  orderFormImportTemplate, orderFormImportData, orderFormLinkGoods, orderFormMpShare,
  orderFormUpload,
} from '@/api/orderForm'
import { exportExcel } from '@/utils/excel'
import GoodsSelect from '@/components/GoodsSelect/index.vue'
import { inventoryReportList } from '@/api/report'

export default {
  name: 'OrderFormDetail',
  components: { GoodsSelect },
  data() {
    return {
      formId: null,
      form: {},
      tab: 'category',
      bootLoading: false,
      saving: false,
      categories: [],
      categoryColumns: [
        { title: '名称', dataIndex: 'name' },
        { title: '产品数', dataIndex: 'product_count', width: 80 },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' }, width: 80 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 160 },
      ],
      catVisible: false,
      catForm: {},
      products: [],
      productLoading: false,
      productFilter: { category: undefined, search: '', page: 1, page_size: 20 },
      productPagination: { current: 1, total: 0, pageSize: 20 },
      productColumns: [
        { title: '图片', dataIndex: 'cover', scopedSlots: { customRender: 'cover' }, width: 70 },
        { title: '产品', dataIndex: 'name', width: 140 },
        { title: '分类', dataIndex: 'category_name', width: 110 },
        { title: '成分', dataIndex: 'ingredients', ellipsis: true },
        { title: '主要防治', dataIndex: 'control_targets', ellipsis: true },
        { title: '使用量', dataIndex: 'dosage', width: 120 },
        { title: '规格价格', dataIndex: 'specs', scopedSlots: { customRender: 'specs' }, width: 180 },
        { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' }, width: 70 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 150 },
      ],
      prodVisible: false,
      prodForm: { specs: [] },
      banners: [],
      bannerLoading: false,
      bannerVisible: false,
      bannerUploading: false,
      bannerForm: {},
      bannerProducts: [],
      coverUploading: false,
      bannerColumns: [
        { title: '图片', dataIndex: 'image', scopedSlots: { customRender: 'image' }, width: 140 },
        { title: '标题', dataIndex: 'title' },
        { title: '点击跳转', dataIndex: 'link_type', scopedSlots: { customRender: 'link' }, width: 200 },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' }, width: 80 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 160 },
      ],
      importLoading: false,
      linkLoading: false,
      shareVisible: false,
      shareLoading: false,
      share: null,
    }
  },
  computed: {
    publicUrl() {
      if (!this.form.slug) return '#'
      return `${window.location.origin}/f/${this.form.slug}`
    },
    shareH5Url() {
      if (this.share && this.share.h5_url) return this.share.h5_url
      if (this.share && this.share.h5_path) return `${window.location.origin}${this.share.h5_path}`
      return this.publicUrl
    },
  },
  methods: {
    openShare() {
      if (!this.formId) return
      this.shareVisible = true
      this.share = null
      this.shareLoading = true
      orderFormMpShare(this.formId)
        .then((data) => { this.share = data || {} })
        .catch(() => this.$message.error('获取分享信息失败'))
        .finally(() => { this.shareLoading = false })
    },
    copyText(text) {
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$message.success('已复制'))
      } else {
        this.$message.info(text)
      }
    },
    linkGoods() {
      this.linkLoading = true
      orderFormLinkGoods(this.formId, { only_unlinked: true })
        .then((res) => {
          const linked = (res && res.linked) || 0
          const unmatched = (res && res.unmatched) || 0
          this.$message.success(`已关联 ${linked} 个产品；未匹配 ${unmatched} 个`)
          const names = (res && res.unmatched_names) || []
          if (names.length) {
            alert('以下产品未匹配到 ERP 商品（可手动编辑关联）：\n\n' + names.join('\n'))
          }
          this.loadProducts()
        })
        .catch(() => this.$message.error('关联失败'))
        .finally(() => { this.linkLoading = false })
    },
    displaySpecStock(item, spec) {
      // 管理端列表：有关联则显示 ERP，否则显示规格手动库存备查
      if (item && (item.goods || item.real_stock != null)) {
        return item.real_stock != null ? item.real_stock : 0
      }
      return (spec && spec.stock) || 0
    },
    onGoodsChange(goodsId) {
      this.prodForm.goods = goodsId || null
      if (!goodsId) {
        this.prodForm.goods_name = null
        this.prodForm.goods_number = null
        this.prodForm.real_stock = null
        return
      }
      inventoryReportList({ goods: goodsId, warehouse: 'null', page_size: 10 }).then((data) => {
        const rows = (data && data.results) || data || []
        const row = Array.isArray(rows) ? rows[0] : null
        this.prodForm.real_stock = row
          ? Math.max(0, Math.floor(Number(row.total_quantity) || 0))
          : 0
      }).catch(() => {
        this.prodForm.real_stock = null
      })
    },
    downloadTemplate() {
      orderFormImportTemplate(this.formId).then((resp) => {
        exportExcel(resp.data, `${this.form.title || '报价单'}-导入模板`)
      }).catch(() => {
        this.$message.error('模板下载失败')
      })
    },
    importExcel(item) {
      const data = new FormData()
      data.append('file', item.file)
      this.importLoading = true
      orderFormImportData(this.formId, data)
        .then((res) => {
          const msg = (res && res.message) || '导入成功'
          const detail = res
            ? `新增产品 ${res.products_created || 0}，更新 ${res.products_updated || 0}；规格新增 ${res.specs_created || 0}，更新 ${res.specs_updated || 0}`
            : ''
          this.$message.success(detail ? `${msg}：${detail}` : msg)
          const warnings = (res && res.warnings) || []
          if (warnings.length) {
            alert('部分规格因缺现价已跳过，产品仍已导入。请稍后补价：\n\n' + warnings.join('\n'))
          }
          this.loadCategories()
          this.loadProducts()
        })
        .catch((err) => {
          const detail = err.response && err.response.data && err.response.data.detail
          if (Array.isArray(detail)) {
            alert('导入错误:\n' + detail.join('\n'))
          } else {
            this.$message.error(detail || '导入失败')
          }
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    boot() {
      this.formId = Number(this.$route.params.id)
      this.bootLoading = true
      orderFormDetail(this.formId).then((data) => {
        this.form = data || {}
      }).finally(() => { this.bootLoading = false })
      this.loadCategories()
      this.loadProducts()
      this.loadBanners()
    },
    loadBanners() {
      this.bannerLoading = true
      orderFormBannerList({ form: this.formId, page_size: 200 })
        .then((data) => { this.banners = data.results || data || [] })
        .finally(() => { this.bannerLoading = false })
    },
    openBanner(item) {
      this.bannerForm = {
        is_active: true,
        sort: 0,
        link_type: 'none',
        image: '',
        title: '',
        ...item,
      }
      this.bannerVisible = true
      // 跳转目标下拉需要全量产品，独立于产品列表的分页
      orderFormProductList({ form: this.formId, page_size: 500 }).then((data) => {
        this.bannerProducts = data.results || data || []
      })
    },
    uploadCover({ file }) {
      this.coverUploading = true
      orderFormUpload(file)
        .then((data) => {
          this.$set(this.prodForm, 'cover', (data && data.url) || '')
          this.$message.success('上传成功')
        })
        .catch(() => this.$message.error('上传失败'))
        .finally(() => { this.coverUploading = false })
    },
    uploadBanner({ file }) {
      this.bannerUploading = true
      orderFormUpload(file)
        .then((data) => {
          this.$set(this.bannerForm, 'image', (data && data.url) || '')
          this.$message.success('上传成功')
        })
        .catch(() => this.$message.error('上传失败'))
        .finally(() => { this.bannerUploading = false })
    },
    saveBanner() {
      if (!this.bannerForm.image) {
        this.$message.warning('请先上传或填写图片地址')
        return
      }
      if (this.bannerForm.link_type === 'product' && !this.bannerForm.product) {
        this.$message.warning('请选择要跳转的产品')
        return
      }
      if (this.bannerForm.link_type === 'category' && !this.bannerForm.category) {
        this.$message.warning('请选择要跳转的分类')
        return
      }
      this.saving = true
      const api = this.bannerForm.id ? orderFormBannerUpdate : orderFormBannerCreate
      api({ ...this.bannerForm, form: this.formId })
        .then(() => {
          this.$message.success('保存成功')
          this.bannerVisible = false
          this.loadBanners()
        })
        .finally(() => { this.saving = false })
    },
    removeBanner(id) {
      orderFormBannerDestroy({ id }).then(() => {
        this.$message.success('已删除')
        this.loadBanners()
      })
    },
    loadCategories() {
      orderFormCategoryList({ form: this.formId, page_size: 200 }).then((data) => {
        this.categories = data.results || data || []
      })
    },
    openCategory(item) {
      this.catForm = { is_active: true, sort: 0, form: this.formId, ...item }
      this.catVisible = true
    },
    saveCategory() {
      if (!this.catForm.name) {
        this.$message.warning('请填写分类名称')
        return
      }
      this.saving = true
      const api = this.catForm.id ? orderFormCategoryUpdate : orderFormCategoryCreate
      api({ ...this.catForm, form: this.formId }).then(() => {
        this.$message.success('保存成功')
        this.catVisible = false
        this.loadCategories()
      }).finally(() => { this.saving = false })
    },
    removeCategory(id) {
      orderFormCategoryDestroy({ id }).then(() => {
        this.$message.success('已删除')
        this.loadCategories()
        this.loadProducts()
      })
    },
    loadProducts() {
      this.productLoading = true
      orderFormProductList({
        form: this.formId,
        category: this.productFilter.category,
        search: this.productFilter.search,
        page: this.productFilter.page,
        page_size: this.productFilter.page_size,
      }).then((data) => {
        this.products = data.results || []
        this.productPagination.total = data.count || 0
      }).finally(() => { this.productLoading = false })
    },
    productTableChange(pagination) {
      this.productPagination = pagination
      this.productFilter.page = pagination.current
      this.productFilter.page_size = pagination.pageSize
      this.loadProducts()
    },
    addSpec() {
      if (!this.prodForm.specs) this.prodForm.specs = []
      this.prodForm.specs.push({
        name: '默认规格', price: 0, original_price: undefined, stock: 0, unit: '件', is_active: true,
      })
    },
    openProduct(item) {
      const specs = (item.specs && item.specs.length)
        ? item.specs.map((s) => ({ ...s }))
        : [{ name: '默认规格', price: 0, original_price: undefined, stock: 0, unit: '件', is_active: true }]
      this.prodForm = {
        is_active: true,
        sort: 0,
        form: this.formId,
        category: item.category,
        ...item,
        specs,
      }
      this.prodVisible = true
    },
    saveProduct() {
      if (!this.prodForm.category || !this.prodForm.name) {
        this.$message.warning('请填写分类和产品名称')
        return
      }
      if (!this.prodForm.specs || !this.prodForm.specs.length) {
        this.$message.warning('请至少添加一个规格')
        return
      }
      this.saving = true
      const payload = { ...this.prodForm, form: this.formId }
      if (!payload.goods) payload.goods = null
      const api = payload.id ? orderFormProductUpdate : orderFormProductCreate
      api(payload).then(() => {
        this.$message.success('保存成功')
        this.prodVisible = false
        this.loadProducts()
        this.loadCategories()
      }).finally(() => { this.saving = false })
    },
    removeProduct(id) {
      orderFormProductDestroy({ id }).then(() => {
        this.$message.success('已删除')
        this.loadProducts()
        this.loadCategories()
      })
    },
  },
  mounted() {
    this.boot()
  },
}
</script>

<style scoped>
.spec-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
</style>
